import { ITheme } from "../../utils/theme";

export const selectStyle = {
  width: { xs: '100%' },
  '& .MuiSelect-select': {
    py: { xs: '6px', sm: '16.5px' }
  },
}

export const selectContainerStyle = () => ({
  width: { xs: '100%', sm: '80%' },
  m: { xs: 0, sm: '0 auto' },
  pt: { xs: 0, sm: 1 }
})

export const selectContainerItemStyle = () => ({
  pr: { xs: 1, sm: 6 },
  pl: { xs: 1, sm: 6 },
  mb: { xs: 0.5, sm: 2 }
})

export const brochureButtonStyle = {
  float: 'right',
  mb: 1,
}

export const lastUpdateStyle = (theme: ITheme) => ({
  color: theme.palette.blue[900],
  fontWeight: 'bold',
})

export const asteriskStyle = {
  color: (theme: ITheme) => theme.palette.red.A700
}

export const PdfIconStyle = (theme: ITheme) => ({
  display: 'inline-block',
  mr: 1,
  fill: theme.palette.red[600],
});

export const casualMandateNormalStyle = {
  mb: 1,
  width: '100%',
  textAlign: 'center'
}

export const fixedSectionStyle = {
  position: 'fixed',
  top: '64px',
  left: '50%',
  p: 1,
  boxSizing: 'border-box',
  background: 'white',
  width: { xs: '100%', md: '75%' },
  ml: { xs: '-50%', md: '-37.5%' },
  zIndex: 1,
  justifyContent: 'center'
}

export const fixedStateContentWrapper = {
  marginTop: "241.5px"
}